import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { MAIN_DOMAIN } from '@app/app.constants';
import { flatMap } from 'rxjs/operators';

import { StudentClass } from '@df/interfaces';

@Injectable({
    providedIn: 'root'
})
export class SchoolService {
    constructor(private http: HttpClient) {}

    public getSchools(): Observable<any> {
        return this.http.get<any>(`${MAIN_DOMAIN}/api/main/boxes_schools/`);
    }

    public getSchool(schoolID: number): Observable<any> {
        return this.http.get<any>(`${MAIN_DOMAIN}/api/main/schools/${schoolID}/`);
    }

    public getSchoolByStudentClass(studentClass: StudentClass) {
        const schoolID = studentClass.school;
        return this.getSchools().pipe(
            flatMap((next: any) => {
                for (const school of next.results) {
                    if (schoolID === school.id) {
                        return school;
                    }
                }
            })
        );
    }
}
